import { z } from 'zod/mini'

export const snoozeDaysSchema = z.int().check(z.minimum(1))

export const formatSnoozeUntil = (releaseAt: number, locale: string) =>
  new Date(releaseAt).toLocaleString(locale, {
    dateStyle: 'medium',
  })
